var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.7 25.9",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.6c-.3 0-.5 0-.7-.2-.2-.1-.3-.2-.3-.5V10c0-.3.1-.5.3-.7L9 .3c.2-.2.4-.3.7-.3.3 0 .5.1.7.3l9.6 9.9c.2.2.3.4.3.7l.4 13.9c0 .3-.1.5-.3.7-.2.2-.4.2-.7.2L1 25.6zm1-15.2v13.5h16.7l-.3-12.5-8.7-9-7.7 8z"
  })));
}

export default SvgHome;